/* Upsell « Faites-en un kit » : ajout panier direct + pop-up photo.
   Delegation sur document (le bloc complementary est injecte en AJAX). */
(function () {
  if (window.__hceKitInit) return;
  window.__hceKitInit = true;

  function updateCount(count) {
    document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
      var s = b.querySelector('span[aria-hidden="true"]') || b.querySelector('span');
      if (s) s.textContent = count;
      b.classList.remove('hidden');
    });
  }

  function refreshCart() {
    fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        if (s['cart-icon-bubble']) {
          var ib = document.getElementById('cart-icon-bubble');
          if (ib) ib.innerHTML = s['cart-icon-bubble'];
        }
        if (s['cart-drawer']) {
          var d = document.querySelector('cart-drawer');
          if (d) {
            var tmp = document.createElement('div');
            tmp.innerHTML = s['cart-drawer'];
            var nd = tmp.querySelector('cart-drawer');
            if (nd) { d.innerHTML = nd.innerHTML; d.classList.remove('is-empty'); }
          }
        }
      }).catch(function () {});
  }

  function openDrawer() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') { d.open(); return true; }
    return false;
  }

  // Change de variante -> change la photo de la carte
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.hce-kit__select');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;
    var card = sel.closest('.hce-kit__card');
    if (!card) return;
    var thumb = opt.getAttribute('data-img');
    var full = opt.getAttribute('data-full');
    var imgEl = card.querySelector('.hce-kit__img img');
    var imgBtn = card.querySelector('.hce-kit__img');
    if (thumb && imgEl) imgEl.src = thumb;
    if (full && imgBtn) imgBtn.setAttribute('data-full', full);
  });

  // Sauvegarde le texte original (prix + prix barré) des boutons natifs avant toute modification,
  // pour pouvoir les restaurer exactement quand on repasse sur "seul".
  function cacheOriginalButtonPrices() {
    document.querySelectorAll(
      '.pdp-main-atc-price, .pdp-main-atc-compare, .sticky-atc-price-inline, .sticky-atc-price-inline-compare'
    ).forEach(function (el) {
      if (!el.hasAttribute('data-hce-original')) el.setAttribute('data-hce-original', el.textContent);
      if (!el.hasAttribute('data-hce-original-hidden')) el.setAttribute('data-hce-original-hidden', el.classList.contains('is-hidden') ? '1' : '0');
    });
  }

  // Reflète le choix (seul/bundle) dans le prix affiché par le bouton natif "Ajouter au panier"
  // (bouton principal + barre collante, mêmes classes de prix des deux côtés).
  function syncButtonPrice(bundle) {
    cacheOriginalButtonPrices();
    var radio = bundle.querySelector('.hce-bundle__options input[type="radio"]:checked');
    var isBundle = radio && radio.value === 'bundle';
    var priceEls = document.querySelectorAll('.pdp-main-atc-price, .sticky-atc-price-inline');
    var compareEls = document.querySelectorAll('.pdp-main-atc-compare, .sticky-atc-price-inline-compare');
    if (isBundle) {
      var kitOpt = bundle.querySelector('.hce-bundle__card--kit');
      var nowEl = kitOpt.querySelector('.hce-bundle__price-now');
      var strikeEl = kitOpt.querySelector('.hce-bundle__price-strike');
      var nowText = nowEl ? nowEl.textContent.trim() : '';
      var strikeText = strikeEl ? strikeEl.textContent.trim() : '';
      if (nowText) priceEls.forEach(function (el) { el.textContent = nowText; });
      compareEls.forEach(function (el) {
        if (strikeText) { el.textContent = strikeText; el.style.display = ''; el.classList.remove('is-hidden'); }
        else { el.classList.add('is-hidden'); }
      });
    } else {
      priceEls.forEach(function (el) { el.textContent = el.getAttribute('data-hce-original') || el.textContent; });
      compareEls.forEach(function (el) {
        el.textContent = el.getAttribute('data-hce-original') || el.textContent;
        el.classList.toggle('is-hidden', el.getAttribute('data-hce-original-hidden') === '1');
      });
    }
  }

  // Le thème a son propre script (snippets/new-atc.liquid) qui réécrit le prix de la barre
  // collante sur CHAQUE "change" du document (variant picker inclus), sans connaître le bundle
  // -> il repasse le prix natif juste après notre synchro. On réapplique donc systématiquement
  // APRÈS lui : setTimeout(…, 0) s'exécute une fois tous les listeners synchrones du même
  // événement terminés, donc toujours après ce script, quel que soit l'ordre d'enregistrement.
  function resyncAllBundlePrices() {
    document.querySelectorAll('.hce-bundle').forEach(function (bundle) { syncButtonPrice(bundle); });
  }

  // Choix de formule (seul / kit) : la classe .is-kit sur le bloc active la carte verte et
  // "dégrise" les cadeaux. Le détail du kit reste toujours visible dans la carte.
  document.addEventListener('change', function (e) {
    var radio = e.target.closest('.hce-bundle__options input[type="radio"]');
    if (!radio) return;
    var bundle = radio.closest('.hce-bundle');
    if (!bundle) return;
    bundle.querySelectorAll('.hce-bundle__card').forEach(function (opt) {
      opt.classList.toggle('is-selected', opt.contains(radio) && radio.checked);
    });
    bundle.classList.toggle('is-kit', radio.value === 'bundle');
    syncButtonPrice(bundle);
  });

  // Variante (couleur/taille) changée ailleurs sur la page -> réaffirme le prix bundle.
  // Filet de sécurité pour les cas synchrones (garde le comportement existant).
  document.addEventListener('change', function (e) {
    if (e.target.closest('.hce-bundle')) return; // déjà géré ci-dessus
    setTimeout(resyncAllBundlePrices, 0);
  });

  // Le VRAI point de rupture : après un changement de variante, VariantRadios.renderProductInfo()
  // (global.js) fait un fetch réseau ASYNCHRONE puis appelle updateStickyATC(html), qui remplace
  // ENTIÈREMENT le innerHTML du conteneur .sticky-atc par du HTML fraîchement rendu côté serveur
  // (donc sans connaissance du bundle). Ça arrive bien après notre setTimeout(…, 0) ci-dessus,
  // à un délai qui dépend du réseau -> impossible à anticiper avec un simple timer.
  // On observe donc directement les mutations du conteneur et on réapplique le prix bundle
  // à chaque fois que son contenu change, quel que soit le mécanisme ou le délai réel.
  (function watchStickyAtcReplacement() {
    var container = document.querySelector('.sticky-atc');
    if (!container) return;
    var syncing = false;
    var mo = new MutationObserver(function () {
      if (syncing) return;
      syncing = true;
      resyncAllBundlePrices();
      // Laisse les mutations qu'on vient de générer nous-mêmes se vider avant de réarmer,
      // sinon syncButtonPrice() (qui modifie ce même conteneur) redéclencherait cet observer
      // indéfiniment.
      setTimeout(function () { syncing = false; }, 0);
    });
    mo.observe(container, { childList: true, subtree: true });
  })();

  // ── Ajout du KIT au panier ─────────────────────────────────────────────────
  // Le bouton "Ajouter au panier" natif (thème / app Lumin) fait sa PROPRE écriture
  // /cart/add.js pour le harnais. Shopify n'accepte pas deux écritures panier
  // concurrentes sur le même token : si on ajoute la laisse + les cadeaux dans une
  // requête PARALLÈLE, l'une des deux écritures écrase l'autre (ou les deux tombent
  // en HTTP 429) et le panier finit incomplet — harnais seul, ou cadeaux sans harnais.
  //
  // -> Quand la formule "Kit" est cochée, on PREND LA MAIN sur tout l'ajout :
  //    preventDefault + stopImmediatePropagation en CAPTURE sur window (donc avant
  //    tout listener du thème), puis UNE SEULE requête /cart/add.js atomique avec les
  //    4 lignes (harnais + laisse choisie + guide + distributeur). Zéro course.
  //    Formule "seul" (ou infos manquantes) -> on ne touche à rien, flux natif normal.

  function hceFindAddForm(btn) {
    return (btn && btn.form) || (btn && btn.closest && btn.closest('form')) ||
      document.querySelector('form[action*="/cart/add"]');
  }

  // ── Cross-sell « Souvent acheté ensemble » ──────────────────────────────
  // Cases à cocher indépendantes du bundle (assets/hce-crosssell.liquid).
  // Ajoutées 2026-09-07 : mêmes principes que le kit -> une case cochée ne
  // part JAMAIS dans une requête /cart/add.js séparée, elle rejoint la
  // requête unique du harnais (ou du kit) plus bas dans hceKitAdd.
  function hceCrosssellItems(formIdAttr) {
    var host = document.querySelector('.hce-crosssell[data-product-form="' + formIdAttr + '"]');
    if (!host) return [];
    var items = [];
    host.querySelectorAll('.hce-crosssell__check:checked').forEach(function (chk) {
      var id = Number(chk.value);
      if (id) items.push({ id: id, quantity: 1 });
    });
    return items;
  }

  function hceKitItems(form, bundle) {
    var idField = form.querySelector('[name="id"]');
    var harnaisId = idField ? Number(idField.value) : 0;
    var qtyInput = form.querySelector('input[name="quantity"]');
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    var leashField = bundle.querySelector('.hce-bundle__leash-select');
    var leashId = leashField ? Number(leashField.value) : 0;
    if (!harnaisId || !leashId) return null;
    var items = [{ id: harnaisId, quantity: qty }, { id: leashId, quantity: qty }];
    (bundle.getAttribute('data-gift-variants') || '').split(',').forEach(function (raw) {
      var gid = parseInt(raw, 10);
      if (gid && gid !== leashId && gid !== harnaisId) items.push({ id: gid, quantity: qty });
    });
    return items;
  }

  // 1 seule requête, avec 2 retries espacés si Shopify répond 429 (throttling panier).
  function hceKitPost(items, attempt) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (r.status === 429 && (attempt || 0) < 2) {
        return new Promise(function (res) { setTimeout(res, 500); })
          .then(function () { return hceKitPost(items, (attempt || 0) + 1); });
      }
      if (!r.ok) throw new Error('add ' + r.status);
      return r.json();
    });
  }

  function hceKitAdd(e, form) {
    if (!form || !form.getAttribute) return;
    var formIdAttr = form.getAttribute('id');
    if (!formIdAttr) return;
    var bundle = document.querySelector('.hce-bundle[data-product-form="' + formIdAttr + '"]');
    var radio = bundle ? bundle.querySelector('.hce-bundle__options input[type="radio"]:checked') : null;
    var isBundle = !!(radio && radio.value === 'bundle');
    var extraItems = hceCrosssellItems(formIdAttr);

    // Ni kit, ni accessoire coché -> flux natif inchangé (comportement d'aujourd'hui).
    if (!isBundle && extraItems.length === 0) return;

    // Verrou anti-double-envoi : porté par le bloc bundle s'il existe, sinon par le form lui-même
    // (cas "accessoire seul coché, pas de kit sur ce produit").
    var lockHost = bundle || form;
    if (lockHost.getAttribute('data-hce-adding') === '1') { e.preventDefault(); e.stopImmediatePropagation(); return; }

    var items;
    if (isBundle) {
      items = hceKitItems(form, bundle);                 // harnais + laisse + cadeaux
      if (!items) return;                                // sécurité : on laisse le natif gérer
      // Un accessoire coché peut être le MÊME produit qu'un cadeau du kit (ex. le
      // distributeur, offert dans le kit ET proposable seul en cross-sell) : on ne
      // l'ajoute pas deux fois, sinon la ligne panier double et le "offert" du kit
      // se retrouve facturé une 2e fois au plein tarif.
      extraItems = extraItems.filter(function (ei) {
        return !items.some(function (it) { return it.id === ei.id; });
      });
      items = items.concat(extraItems);
    } else {
      var idField = form.querySelector('[name="id"]');
      var harnaisId = idField ? Number(idField.value) : 0;
      var qtyInput = form.querySelector('input[name="quantity"]');
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      if (!harnaisId) return;                             // sécurité : on laisse le natif gérer
      items = [{ id: harnaisId, quantity: qty }].concat(extraItems);
    }

    e.preventDefault();
    e.stopImmediatePropagation();
    lockHost.setAttribute('data-hce-adding', '1');
    var btns = document.querySelectorAll('button[type="submit"][name="add"], .sticky-atc-button, [data-hce-atc]');
    btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });

    hceKitPost(items, 0)
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) { updateCount(cart.item_count); refreshCart(); openDrawer(); })
      .catch(function () { form.submit(); })              // dernier recours : ajout natif du harnais (submit() ne re-déclenche pas l'event)
      .then(function () {
        lockHost.removeAttribute('data-hce-adding');
        btns.forEach(function (b) { b.removeAttribute('aria-busy'); });
      });
  }

  // Capture sur window : tout premier point d'interception, avant n'importe quel
  // listener du thème (document ou élément).
  window.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest('button[type="submit"][name="add"], .sticky-atc-button, [data-hce-atc]') : null;
    if (!btn) return;
    hceKitAdd(e, hceFindAddForm(btn));
  }, true);

  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.matches && form.matches('form[action*="/cart/add"]')) hceKitAdd(e, form);
  }, true);

  // Menu déroulant couleur de laisse -> la valeur (id de variante) est lue telle quelle par
  // l'ajout au panier. Au changement : on synchronise la vignette de la laisse dans le kit
  // et la cible du zoom (data-full).
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('select.hce-bundle__leash-select');
    if (!sel) return;
    var bundle = sel.closest('.hce-bundle');
    if (!bundle) return;
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;
    var thumb = opt.getAttribute('data-img');
    var full = opt.getAttribute('data-full');
    if (thumb) {
      bundle.querySelectorAll('.hce-bundle__img-leash').forEach(function (img) { img.src = thumb; });
    }
    if (full) {
      bundle.querySelectorAll('.hce-bundle__item--leash').forEach(function (btn) { btn.setAttribute('data-full', full); });
    }
  });

  // Variante du harnais changée (couleur/taille) dans le sélecteur natif du thème -> on
  // resynchronise dans le bloc kit : la photo du harnais + le libellé "Violet · M" (lecture seule).
  // Sondage léger car le sélecteur de variante (app Lumin) ne garantit pas d'événement custom fiable.
  (function watchHarnaisVariant() {
    var bundles = document.querySelectorAll('.hce-bundle[data-harnais-images]');
    if (!bundles.length) return;
    var state = [];
    bundles.forEach(function (bundle) {
      var formId = bundle.getAttribute('data-product-form');
      var input = formId ? document.querySelector('#' + formId + ' input[name="id"]') : null;
      var images = {};
      var titles = {};
      try { images = JSON.parse(bundle.getAttribute('data-harnais-images')); } catch (err) {}
      try { titles = JSON.parse(bundle.getAttribute('data-harnais-variants') || '{}'); } catch (err) {}
      state.push({ bundle: bundle, input: input, images: images, titles: titles, last: input ? input.value : null });
    });
    setInterval(function () {
      state.forEach(function (s) {
        if (!s.input) return;
        var val = s.input.value;
        if (val === s.last) return;
        s.last = val;
        var src = s.images[val];
        if (src) s.bundle.querySelectorAll('.hce-bundle__img-main').forEach(function (img) { img.src = src; });
        var label = s.titles[val];
        if (label) s.bundle.querySelectorAll('[data-harnais-variant]').forEach(function (el) { el.textContent = label; });
      });
    }, 400);
  })();

  document.addEventListener('click', function (e) {
    var leashZoom = e.target.closest('.hce-bundle__item--leash');
    if (leashZoom) {
      e.preventDefault();
      var leashFull = leashZoom.getAttribute('data-full');
      if (leashFull) openLightbox(leashFull);
      return;
    }

    var add = e.target.closest('.hce-kit__add');
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      var card = add.closest('.hce-kit__card');
      var sel = card ? card.querySelector('.hce-kit__select') : null;
      var id = sel ? sel.value : add.getAttribute('data-variant');
      if (!id) return;
      var original = add.textContent;
      add.disabled = true; add.textContent = 'Ajout…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          updateCount(cart.item_count);
          refreshCart();
          add.textContent = 'Ajouté ✓';
          add.classList.add('is-added');
          if (!openDrawer()) { /* pas de tiroir : on laisse le feedback bouton */ }
          setTimeout(function () { add.textContent = original; add.disabled = false; add.classList.remove('is-added'); }, 2000);
        })
        .catch(function () { add.textContent = original; add.disabled = false; });
      return;
    }

    var img = e.target.closest('.hce-kit__img');
    if (img) {
      e.preventDefault();
      var full = img.getAttribute('data-full');
      if (full) openLightbox(full);
    }
  });

  var lb;
  function openLightbox(src) {
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'hce-lightbox';
      lb.innerHTML = '<div class="hce-lightbox__backdrop"></div><div class="hce-lightbox__inner"><button type="button" class="hce-lightbox__close" aria-label="Fermer">&times;</button><img alt=""></div>';
      document.body.appendChild(lb);
      lb.addEventListener('click', function (e) {
        if (e.target.closest('.hce-lightbox__close') || e.target.classList.contains('hce-lightbox__backdrop')) closeLightbox();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLightbox(); });
    }
    lb.querySelector('img').src = src;
    lb.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (lb) { lb.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
  }
})();



/* ── Timer d'offre kit ────────────────────────────────────────────────────────
   Décompte depuis le nombre de secondes restantes fourni par le serveur
   (data-seconds-left), compté localement (immunisé contre l'horloge du client).
   À 0 -> reload : la fiche re-rend l'autre phase (bloc kit affiché / masqué). */
(function hceKitTimer() {
  var clock = document.querySelector('[data-hce-clock]');
  var host = clock && clock.closest('[data-seconds-left]');
  if (!host) return;
  var total = parseInt(host.getAttribute('data-seconds-left'), 10);
  if (isNaN(total)) return;
  var start = Date.now();
  var done = false;

  function fmt(s) {
    if (s < 0) s = 0;
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    return (d > 0 ? d + 'j ' : '') + (d > 0 || h > 0 ? p(h) + 'h ' : '') + p(m) + 'm ' + p(s) + 's';
  }

  function tick() {
    var left = total - Math.floor((Date.now() - start) / 1000);
    clock.textContent = fmt(left);
    if (left <= 0 && !done) {
      done = true;
      setTimeout(function () { location.reload(); }, 1200);
    }
  }
  tick();
  setInterval(tick, 1000);
})();
